<template>
    <b-button variant="primary" @click.stop="exportar()" v-if="mostrarBtn">
        <i class="fa fa-file-pdf-o mr-2"></i> Exportar
    </b-button>
</template>

<script>
import download from './../../../../shared/download'

export default {
    props: {
        finalizacao: {
            type: Object,
            default: () => {}
        },

        finalizacoesServicos: {
            type: Object,
            required: true
        }
    },

    data() {
        return {}
    },

    methods: {
        exportar() {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos
                .exportar(this.finalizacao.finalizacaoId)
                .then((response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Falha ao exportar o Registro de Pagamentos',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            download(
                                response,
                                `RegistroDePagamento_${this.finalizacao.protocolo}.pdf`
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {},

    computed: {
        mostrarBtn() {
            return (
                this.$temAcessoView('CRED-UABS-FIN-05') &&
                this.finalizacao.status === 9
            )
        }
    },

    watch: {},

    validations: {}
}
</script>
